import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router";
import { useFiltersStore } from "@companion-core/shared/app/Store/filters";

export const useFiltersInQueryParams = () => {
  const [params, setSearchParams] = useSearchParams();
  const { filters, search, setFilters, setSearch } = useFiltersStore();
  const isInitialSync = useRef(true);

  useEffect(() => {
    const querySearch = params.get("search");
    const queryFilters: Record<string, string> = {};
    const queryParams = params?.entries();
    let queryParam = queryParams.next();
    while (!queryParam.done) {
      if (queryParam.value[0] === "search") {
        queryParam = queryParams.next();
        continue;
      }
      queryFilters[queryParam.value[0]] = queryParam.value[1];
      queryParam = queryParams.next();
    }

    if (queryFilters) setFilters(queryFilters);
    if (querySearch) setSearch(querySearch);
  }, []);

  useEffect(() => {
    const replace = isInitialSync.current;
    if (filters || search) {
      isInitialSync.current = false;
    }
    setSearchParams({ ...(search && { search }), ...(filters && filters) }, { replace });
  }, [filters, search]);
};
